import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import LoadingBarPortal from '../loading-bar/portal/LoadingBarPortal';
import RecentlyPlayed from './recently-played/RecentlyPlayed';
import cx from 'classnames';

import styles from './RecentlyPlayedList.pcss';

const getButtonProps = (game, props) => {
    const {isPromo, productNamespaceMappings} = props;

    const detailsLink = `product/${productNamespaceMappings.get(game.namespace)}`;

    return {
        isPromo,
        detailsLink,
        ...game
    };
};

const Placeholder = () => (
    <Fragment>
        <LoadingBarPortal />
        <ul className={styles.wrapper}>
            <li className={styles.placeholder} />
        </ul>
    </Fragment>
);

const RecentlyPlayedList = React.forwardRef((props, ref) => {
    const {games, buttonActions, customStyles, useDynamicSpacing} = props;

    const hasLoadedRecentGames = games && games.size;
    if (!hasLoadedRecentGames) return <Placeholder />;

    const trimmedGames = games.take(3);

    const containerClasses = cx(styles.container, {
        [styles.dynamicSpacing]: useDynamicSpacing
    });

    return (
        <div className={containerClasses} style={customStyles}>
            <ul className={styles.wrapper} ref={ref}>
                {trimmedGames.map(game => (
                    <RecentlyPlayed
                        key={game.id}
                        gameKey={game.id}
                        percent={game.percent}
                        background={game.background}
                        logo={game.logo}
                        buttonActions={buttonActions}
                        buttonProps={getButtonProps(game, props)}
                    />
                ))}
            </ul>
        </div>
    );
});

RecentlyPlayedList.propTypes = {
    games: ImmutablePropTypes.listOf(
        PropTypes.shape({
            background: PropTypes.string,
            id: PropTypes.string,
            namespace: PropTypes.string,
            logo: PropTypes.string,
            percent: PropTypes.number,
            hasUpdate: PropTypes.bool
        })
    ),
    buttonActions: PropTypes.object.isRequired,
    customStyles: PropTypes.object,
    useDynamicSpacing: PropTypes.bool
};

export default RecentlyPlayedList;
